export default __webpack_public_path__ + "static/media/HomeBuddyLogo_FullColour_PrimaryLockup.37a02bcb.svg";